import { PriceState } from 'src/store/price/types';
import { PayloadAction } from '@reduxjs/toolkit';

const setCurrencyIdReducer = (state: PriceState, action: PayloadAction<string | undefined>) => {
  state.currencyId = action.payload;
};

export default setCurrencyIdReducer;
